/* eslint-disable camelcase */
export interface Entity {
  id: string;
  isPublic: boolean;
  isActive: boolean;
  locRegion: {
    totalFintechs: number;
    id: string;
    totalEntities: number;
    name: string;
    totalNeobanks: number;
    totalBanks: number;
  };
  complianceLevels: {
    id: string;
    name: string;
    description: string;
  }[];
  locCountry: string;
  locCountryCode: string;
  description: string;
  entityType: string;
  subdomain: string;
  shortName: string;
  legalName: string;
  displayName: string;
  logo: string;
  primaryColor: string;
  createdAt: string;
  updatedAt: string;
  accentColor: string;
  showProcess: boolean;
  showTestimonials: boolean;
  showNews: boolean;
  showPartnerships: boolean;
  showShowcase: boolean;
  showSubscribe: boolean;
  showApps: boolean;
  showApis: boolean;
  showServices: boolean;
  contact: string;
  faq: string;
  apiPortalLink: string;
  contactUs: string;
  aboutUs: string;
  termsAndConditions: string;
  privacyPolicy: string;
  landingPageTitleLine1: string;
  landingPageTitleLine2: string;
  landingPageTitleLine3: string;
  landingPageWelcomeHeaderText: string;
  landingPageWelcomeBodyText: string;
  landingPageAppIntroHeaderText: string;
  landingPageAppIntroBodyText: string;
  landingPageApiIntroHeaderText: string;
  landingPageApiIntroBodyText: string;
  landingPageApiIntroPendingText: string;
  landingPageNewsIntroText: string;
  dataSource: string;
  rating: number;
  numRaters: number;
  webSiteLink: string;
  apiEnabled: boolean;
  address?: Address;
  updatedBy?: string;
  createdBy?: string;
  facebook: string;
  linkedIn: string;
  twitter: string;
  tags?: string[];
  entityFeatures?: FeatureItem[];
  isAvailable: boolean;
  sponsored: boolean;
  sponsorRating: number;
}

export interface EntityApps extends Entity {
  appInfo: AppInfo[];
}

export interface FeatureItem {
  id: string;
  industry: string;
  featureItem: string;
  icon: string;
  featureDescription: string;
  order: number;
  active: boolean;
}

export enum FeatureType {
  APP = 'app',
  API = 'api',
  ENTITY = 'entity',
}

export interface FilterOption {
  [checkbox: string]: OptionFilter;
}

export interface EntityComparison {
  id: string;
  apiEnabled: boolean;
  entityId: string;
  subdomain: string;
  displayName: string;
  legalName: string;
  logo: string;
  complianceLevels: string[];
  country: string;
  playStoreLink: string;
  appStoreLink: string;
  storeRatingApple: number;
  storeRatingPlay: number;
  userLike: number;
  appName: string;
  userRating: number;
  starRating: number;
  entityRating: number;
  apiRating: string;
  numRaters: number;
}

export interface Paging {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  isFull?: boolean;
}

export interface OptionFilter {
  label: string;
  checked: boolean;
  dotColor?: string;
  icon?: string;
  value: string;
}

export interface Filter {
  [menu: string]: {
    title: string;
    checkedAll: boolean;
    options: {
      [checkbox: string]: OptionFilter;
    };
    collapseExpandFunction: boolean;
    expand: boolean;
  };
}

export interface ApiCategory {
  id: string;
  industry: string;
  entryType: string;
  name: string;
  icon: string;
  description: string;
  order: number;
}

export interface AppCategory {
  id: string;
  industry: string;
  entryType: string;
  name: string;
  icon: string;
  description: string;
  order: number;
}

export interface Country {
  attributes: {
    active: boolean;
    area: number | string;
    capitalCity: string;
    capitalLatitude: number | string;
    capitalLongtitude: number | string;
    code2: string;
    code3: string;
    currencyInfo: {
      listCurrency: {
        code: string;
        isPrimary: boolean;
        name: string;
        symbol: string;
      }[];
    };
    flagUrlRect: string;
    flagUrlRound: string;
    region: string;
    gdp: number | string;
    idd: string;
    internetHostNumber: number | string;
    internetUserNumber: number | string;
    latitude: number | string;
    longitude: number | string;
    mobilephonesNumber: number | string;
    name: string;
    telephonesNumber: number | string;
    timezone: string;
    entityCount: number;
  };
  id: number | string;
  type: string;
}

export interface Article {
  id: string;
  title: string;
  slug: string;
  sourceUrl: string;
  content: string;
  imageUrl: string;
  summary: string;
  author: string;
  publishedAt: string;
  tags: string[];
  isFeatured: boolean;
  isActive: boolean;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
  rankItem?: RankItem;
  rankItemTemplate?: ERankItemTemplate;
}

export enum ERankItemType {
  APP = 'APP',
  ENTITY = 'ENTITY',
}

export interface RankItem {
  id: string;
  name: string;
  type: ERankItemType;
  createdAt: string;
  updatedAt: string;
}

export interface ComplianceLevel {
  id: string;
  name: string;
  description: string;
}

export enum EntryTypeCategory {
  api = 'API',
  app = 'APP',
}

export interface ParamsUrl {
  location?: string;
  subdomain?: string;
}

export enum Device {
  mobile = 'mobile',
  desktop = 'desktop',
}

export enum Keyboard {
  enter = 'Enter',
  backspace = 'Backspace',
  escape = 'Escape',
  arrowUp = 'ArrowUp',
  arrowDown = 'ArrowDown',
  arrowLeft = 'ArrowLeft',
  arrowRight = 'ArrowRight',
}

export enum LegalDocumentType {
  TERMS_OF_USE = 'terms-of-use',
  ABOUT_US = 'about-us',
  PRIVACY_POLICY = 'privacy-policy',
  FAQ = 'faq',
}

export enum ViewModeLayout {
  grid = 'grid',
  list = 'list',
}

export interface Category {
  id: string;
  industry: string;
  entryType: string;
  name: string;
  categoryName: string;
  icon: string;
  description: string;
  order: number;
}

export type Categories = Category[];

export interface AppInfo {
  id: string;
  // appFeatures: {
  //   id: string;
  //   description: string;
  //   apiCategory: {
  //     id: string;
  //     description: string;
  //   };
  // }[];
  appImageList: string[];
  appStoreLink: string;
  appStoreRating?: number;
  playStoreRating?: number;
  description: string;
  name: string;
  playStoreLink: string;
  updatedAt: string;
  published: boolean;
  sequence: number;
  ratedScore?: number;
  liked?: boolean;
  rating: number;
  numRaters: number;
  thankMessage: string;
  demoVideo: string;
  appFeatures?: FeatureItem[];
  appStoreRatingCount?: number;
  playStoreRatingCount?: number;
}

export type AppsInfo = AppInfo[];

export interface ApiInfo {
  id: string;
  groupName: string;
  apiCategory: Category[];
  apiName: string;
  swagger: string;
  iconName: string;
  apiImage: string;
  slug: string;
  tags: string[];
  postmanCollectionId?: string;
  updatedAt: string;
  description: string;
  isPublic?: boolean;
  votes: number;
  userLikes: number;
  rating: number;
  numRaters: number;
  complianceLevels: ComplianceLevel[];
}

export type ApisInfo = ApiInfo[];

export interface RateAssetForm {
  rateType: string;
  ratedAsset: string;
  ratedId: string;
  ratedScore: number;
  comments?: string;
}

export interface AssetSocial {
  id: string;
  ratedAs: string;
  rateType: string;
  ratedAsset: string;
  ratedId: string;
  ratedScore: number;
  comments: string;
}

export type AssetsSocial = AssetSocial[];

export interface UserSocial {
  socialId: string;
  socialNetwork: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
}

export interface TotalEntitySummary {
  entityType: string;
  totalCount: number;
}
export interface EntitySummary {
  region: string;
  count: number;
  entityType: string;
  complianceGroup: string;
}
export interface EntitySummaries {
  total: TotalEntitySummary[];
  summaries: EntitySummary[];
}

export interface AuthUser {
  firstName: string;
  lastName: string;
  roles: string[];
  organisationId: string;
  email?: string;
}

export enum ReloadType {
  api = 'API',
  app = 'APP',
  data = 'DATA',
}

export interface Place {
  address_components: AddressComponent[];
  adr_address: string;
  business_status: string;
  formatted_address: string;
  formatted_phone_number: string;
  geometry: Geometry;
  icon: string;
  international_phone_number: string;
  name: string;
  opening_hours: OpeningHours;
  photos: Photo[];
  place_id: string;
  plus_code: PlusCode;
  rating: number;
  reference: string;
  reviews: Review[];
  types: string[];
  url: string;
  user_ratings_total: number;
  utc_offset: number;
  vicinity: string;
  website: string;
  html_attributions: any[];
  utc_offset_minutes: number;
}

export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface Geometry {
  location: Location;
  viewport: Viewport;
}

export interface Location {
  lat: any;
  lng: any;
}

export interface Viewport {
  south: number;
  west: number;
  north: number;
  east: number;
}

export interface OpeningHours {
  open_now: boolean;
  periods: Period[];
  weekday_text: string[];
}

export interface Period {
  close: Close;
  open: Close;
}

export interface Close {
  day: number;
  time: string;
  hours: number;
  minutes: number;
  nextDate: number;
}

export interface Photo {
  height: number;
  html_attributions: string[];
  width: number;
}

export interface PlusCode {
  compound_code: string;
  global_code: string;
}

export interface Review {
  author_name: string;
  author_url: string;
  language?: string;
  profile_photo_url: string;
  rating: number;
  relative_time_description: string;
  text: string;
  time: number;
}

export interface Address {
  line1: string;
  line2: string;
  line3: string;
  buildingName: string;
  buildingNumber: string;
  apartmentName: string;
  city: string;
  country: string;
  postcode: string;
  latitude: string;
  longitude: string;
}

export interface CountriesData {
  data: Country[];
  paging: Paging;
}

export enum DashboardProduct {
  BankApi = 'bank-api',
  ApiCafe = 'apicafe',
  Obd = 'openbankingdirectory',
}

export enum DataSource {
  OPEN_BANKING_DIRECTORY = 'OBDirectory',
  API_CAFE = 'ApiCafe',
  BANK_API = 'Bank-API',
  DAKKO_HUB = 'HealthHubApp',
}

export enum EntryType {
  API = 'API',
  APP = 'APP',
  SERVICE = 'SERVICE',
}

export interface ServiceCatalogue {
  id: string;
  serviceCategory: {
    id: string;
    categoryName: string;
    icon: string;
  };
  serviceName: string;
  serviceDescription: string;
  serviceCurrency: string;
  serviceCost: number;
}

export interface Currency {
  name: string;
  code: string;
  symbol: string;
  decimals: number;
  displaySymbol: string;
  displayFormat: string;
  displaySymbolFirst: boolean;
  isoCode: string;
  displaySpace: number;
  logo: string;
}

export interface Status {
  code: string;
  message: string;
}

export interface ServiceCategory {
  id: string;
  categoryName: string;
  name: string;
  industry: string;
  icon: string;
  description: string;
  order: number;
}

export interface FeatureItem {
  id: string;
  industry: string;
  featureItem: string;
  icon: string;
  featureDescription: string;
  order: number;
  active: boolean;
  featureGroup: FeatureGroup;
}

export type FeatureItems = FeatureItem[];
export interface FeatureGroup {
  id: string;
  name: string;
  description: string;
  order: number;
  active: boolean;
  type: string;
}

export enum Events {
  LOGIN = 'login',
  SIGNUP = 'sign_up',
  SEARCH = 'search',
  REGISTER = 'register',
  CONFIRMATION = 'confirmation',
  FORGOT_PASSWORD = 'password_forgot',
  ACTIVE_ACCOUNT = 'active_account',
  PASSWORD_CHANGE = 'password_change',
  RESET_PASSWORD = 'reset_password',
  FILL_ENTITY_INFO = 'fill_entity_info',
  VISIT_WEBSITE = 'visit_website',
  VISIT_FACEBOOK = 'visit_facebook',
  VISIT_LINKEDIN = 'visit_linkedin',
  VISIT_APIPORTAL = 'visit_apiportal',
  SUGGEST_AN_EDIT = 'suggest_an_edit',
  OWN_THIS_BUSINESS = 'own_this_business',
  ENTITY_VIEW = 'entity_view',
  ENTITY_LIKE = 'entity_like',
  ENTITY_SHARE = 'entity_share',
  ENTITY_RATING = 'entity_rating',
  APP_LIKE = 'app_like',
  APP_RATING = 'app_rating',
  DOWNLOAD_APP_ANDROID = 'download_app_android',
  DOWNLOAD_APP_APPLE = 'download_app_apple',
  ENTITY_FEATURE_CLICK = 'entity_feature_click',
  APP_FEATURE_CLICK = 'app_feature_click',
  RELATED_ENTITY_CLICK = 'app_feature_click',
  TAG_CLICK = 'tag_click',
  DIRECTORY_SEARCH_BY_ENTITY_FEATURES = 'directory_search_by_entity_features',
  DIRECTORY_SEARCH_BY_APP_FEATURES = 'directory_search_by_app_features',
  VISIT_NEWS_PAGE = 'visit_news_page',
  NEWS_SEARCH = 'news_search',
  NEWS_SUBSCRIBE = 'news_subscribe',
  NEWS_DETAILS = 'news_details',
}

export enum ERankItemTemplate {
  DEFAULT = 'DEFAULT',
  APPTEMPLATE1 = 'APPTEMPLATE1',
  APPTEMPLATE2 = 'APPTEMPLATE2',
}
